/**
 * Get the site URL for redirects
 * Uses environment variable if available, otherwise falls back to window.location.origin
 * This ensures correct URLs in both development and production
 */

export const getSiteUrl = (): string => {
    // Public app origin for links in toasts/emails when admin runs the app on localhost.
    const siteUrl =
        import.meta.env.VITE_SITE_URL ||
        import.meta.env.VITE_PUBLIC_SITE_URL;

    if (siteUrl && typeof siteUrl === 'string' && siteUrl.startsWith('http')) {
        return siteUrl.replace(/\/+$/, '');
    }

    // Fall back to window.location.origin (works in both dev and production)
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }

    // Server-side fallback (shouldn't happen in client-side code)
    return 'http://localhost:8080';
};

/**
 * Get the full URL for a specific path
 */
export const getSiteUrlForPath = (path: string): string => {
    const baseUrl = getSiteUrl();
    // Ensure path starts with /
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${baseUrl}${normalizedPath}`;
};

